import { useTracking } from '@change-corgi/core-react/tracking';

import type { Topics } from '#src/app/pages/topicSitemap/pageContext';
import { useTopicSitemapPageData } from '#src/app/pages/topicSitemap/pageContext';

type Result = ModelHookResult<
	{
		topics: Topics;
		displayed: boolean;
		hasNextPage: boolean;
		nextPageLoading: boolean;
		totalCount: number;
	},
	{
		loadMore: () => void;
	}
>;

export function useFilterableTopics(): Result {
	const {
		data: { hasNextPage, items, nextPageLoading, totalCount },
		actions: { loadMore },
	} = useTopicSitemapPageData();
	const track = useTracking();

	return {
		data: {
			topics: items,
			displayed: totalCount > 0,
			hasNextPage,
			totalCount,
			nextPageLoading,
		},
		actions: {
			loadMore: () => {
				void track('topic_sitemap_show_more');
				loadMore();
			},
		},
	};
}
